import {InputRule} from 'prosemirror-inputrules'
import {TextSelection} from 'prosemirror-state'
import {icon} from '../utils.mjs'

export default () => ({
  nodes: {
    // :: NodeSpec A Django block
    // as a `<djnode>` block element
    djNode: {
      content: 'text*',
      group: 'block',
      marks: 'djmark',
      toDOM () { return ['djnode', 0] },
      parseDOM: [{tag: 'djnode'}],
    },
  },
  marks: {
    djTag: {
      inclusive: false,
      excludes: '_',
      group: 'inline djmark',
      code: true,
      spanning: true,
      toDOM () { return ['djtag', 0] },
      parseDOM: [{tag: 'djtag'}],
    },
    djVar: {
      inclusive: false,
      excludes: 'djTag',
      group: 'inline djmark',
      code: true,
      spanning: true,
      toDOM () { return ['djvar', 0] },
      parseDOM: [{tag: 'djvar'}],
    },
  },

  blocksMenu (schema) {
    const djNode = schema.nodes.djNode

    return {
      setDjNode: {
        run: setDjBlock(djNode), dom: icon('djNode'), type: djNode,
      },
    }
  },

  // * Parse Dom node source before parsing by Prosemirror
  //   to add <djNode> <djTag> html tags around django template `{% tag %}` & `{{ var }}`
  // * Add <djNode> tag around direct text node childs
  // * return Dom node
  parseDomContent (parentNode, insertDjNode = true) {
    const djTagRegex = /(({%)([^(%})]*)(%}))/g
    const djVarRegex = /(({{)([^(%})]*)(}}))/g

    function parsechilds (node) {
      const childs = [...node.childNodes]
      childs.forEach(child => {
        // loop to descendants
        parsechilds(child)

        if (child.nodeType === Node.TEXT_NODE && child.textContent.trim()) {
          // console.log(child)
          const nextSibling = child.nextSibling
          let parsedText = child.textContent
          if (!['DJTAG', 'DJVAR'].includes(child.parentNode.tagName)) {
            parsedText = child.textContent
              .replaceAll(djTagRegex, '<djtag>$&</djtag>')
              .replaceAll(djVarRegex, '<djvar>$&</djvar>')
          }

          if (insertDjNode && child.parentNode === parentNode) {
            parsedText = '\n<djnode>' + parsedText.trim() + '</djnode>\n'
          }

          child.remove()
          if (nextSibling) {
            nextSibling.insertAdjacentHTML('beforebegin', parsedText)
          } else {
            node.insertAdjacentHTML('beforeend', parsedText)
          }
        }
      })
    }

    parsechilds(parentNode)
    return parentNode
  },

  // * Parse HTML string to add <djNode> <djTag> html tags
  //   around django template `{% tag %}` & `{{ var }}`
  // * DON'T ADD <djNode> tag around direct text node childs
  // * return HTML string
  parseStringContent (HTMLString, insertDjNode = false) {
    let w = document.createElement('div')
    w.innerHTML = HTMLString
    return this.parseDomContent(w, insertDjNode).innerHTML.trim()
  },

  // Parse Godo HTML output to remove <djNode> <djTag> html tags
  // before update source content
  parseGodoContent (godoOutput) {
    const djTagRegex = new RegExp('(</?)(djnode|djtag|djvar)(>)', 'g')
    return godoOutput.replaceAll(djTagRegex, '')
  },

  // define input rules plugins
  djTagInputRules (schema) {
    return [
      djInputRule(/{{$/, '{{  }}', schema.marks.djVar),
      djInputRule(/{%$/, '{%  %}', schema.marks.djTag),
    ]
  },
})


// Command that extend select to completely cover djTag & djVar before launch command
export function extendSelectToDjMark (command) {
  return function (state, dispatch, view) {
    const djTagType = state.schema.marks.djTag
    const djVarType = state.schema.marks.djVar
    if (!djTagType) {
      return command(state, dispatch, view)
    }

    let { from, to, $from, $to } = state.selection
    let fromDjMark
    let toDjMark
    ;[djTagType, djVarType].forEach(markType => {
      if (markType.isInSet($from.marks())) {
        fromDjMark = markType
      }
      if (markType.isInSet($to.marks())) {
        toDjMark = markType
      }
    })

    if (!(fromDjMark || toDjMark)) {
      return command(state, dispatch, view)
    }

    let newState = state

    if (dispatch) {
      let newFrom = from
      let newTo = to
      if (fromDjMark) {
        state.doc.nodesBetween(from, from, (node, pos) => {
          if (!fromDjMark.isInSet(node.marks)) { return }
          newFrom = pos
        })
      }
      if (toDjMark) {
        state.doc.nodesBetween(to - 1, to, (node, pos) => {
          if (!toDjMark.isInSet(node.marks)) { return }
          newTo = pos + node.nodeSize
        })
      }
      let tr = state.tr.setSelection(TextSelection.create(state.doc, newFrom, newTo))
      newState = state.apply(tr)
    }
    return command(newState, dispatch, view)
  }
}


// Command setDjBlock
function setDjBlock (nodeType) {
  return function (state, dispatch) {
    let tr = state.tr
    const ref = state.selection
    const from = ref.from
    const to = ref.to
    let applicableNode = []

    state.doc.nodesBetween(from, to, function (node, pos, parent) {
      if (parent === state.doc) {
        let childsAreDjMarks = true
        node.descendants((node) => {
          if (
            node.marks.length !== 1
            && !(state.schema.marks.djVar.isInSet(node.marks)
            || state.schema.marks.djTag.isInSet(node.marks))
          ) {
            childsAreDjMarks = false
          }
        })
        if (childsAreDjMarks) {
          applicableNode.push({node, pos})
        }
      }
    })
    if (!applicableNode.length) { return false }
    if (dispatch) {
      applicableNode.forEach((node) => {
        tr.setNodeMarkup(node.pos, nodeType)
      })
      dispatch(tr)
    }
    return true
  }
}

function djInputRule (regexp, replaceText, markType) {
  return new InputRule(regexp, (state, match, start, end) => {
    const schema = state.schema
    let tr = state.tr
    tr.replaceWith(start, end, schema.text(replaceText, markType.create()))
    tr.setSelection(TextSelection.create(tr.doc, end + 2))
    return tr
  })
}

